export default "__VITE_ASSET__df09ceeb__"